<script setup>
import { computed, inject } from 'vue';
import { flowThreadContextKey } from './flowThreadContext';

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
});

const context = inject(flowThreadContextKey);

const fileLabel = computed(() => {
  const mediaLabels = {
    image: 'Image',
    video: 'Video',
    audio: 'Audio',
    file: 'PDF / File',
  };

  return mediaLabels[props.node.type] || context.uiCopy.mediaFileFallback;
});
</script>

<template>
  <div class="bg-white px-3 py-3">
    <div class="mb-2.5 overflow-hidden rounded-[0.95rem] bg-n-slate-2">
      <img
        v-if="
          node.type === 'image' &&
          (node.config?.mediaUrl || node.config?.mediaLink)
        "
        :src="node.config?.mediaUrl || node.config?.mediaLink"
        alt=""
        class="h-[5rem] w-full object-cover"
      />
      <div
        v-else
        class="flex h-[5rem] items-center justify-center text-n-slate-10"
      >
        <i class="i-lucide-file-text text-2xl" />
      </div>
    </div>
    <div
      class="flex items-center gap-2.5 rounded-xl bg-n-slate-1 px-2.5 py-2.5"
    >
      <div
        class="flex h-9 w-9 items-center justify-center rounded-xl bg-white text-n-slate-11"
      >
        <i
          class="text-base"
          :class="[
            node.type === 'file'
              ? 'i-lucide-file-text'
              : node.type === 'audio'
                ? 'i-lucide-audio-lines'
                : node.type === 'video'
                  ? 'i-lucide-clapperboard'
                  : 'i-lucide-image',
          ]"
        />
      </div>
      <div class="min-w-0">
        <div class="truncate text-[12px] font-semibold text-n-slate-12">
          {{ node.config?.fileName || fileLabel }}
        </div>
        <div
          class="mt-0.5 text-[11px]"
          :class="node.config?.body ? 'text-n-slate-11' : 'text-n-slate-9'"
        >
          {{ node.config?.body || context.uiCopy.inlineTextPlaceholder }}
        </div>
      </div>
    </div>
    <div class="mt-1.5 flex items-center justify-end gap-1 text-[10px]">
      <span class="text-n-slate-10">{{ context.uiCopy.timestamp }}</span>
    </div>
  </div>
</template>
